import React from 'react';

import { HistoryProps } from './History.props';

import HistoryView from './History.view';

const HistoryContainer = (_: HistoryProps) => {
  return <HistoryView />;
};

export default HistoryContainer;
